import {
  LOGIN,
  LOGOUT,
  SET_ARTISAN
} from '../constants/ActionTypes';

const initialState = {};
export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        token: action.token,
      };
    case SET_ARTISAN:
      return {
        ...state,
        artisan: action.artisan,
      };
    case LOGOUT:
      return {};
    default:
      return state;
  }
};
